@if (workflowOptions) {
    <div class="workflow-container d-flex flex-column">
    <div class="view">
        <!-- Tabs -->
        <mat-tab-group #matTabGroup (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>Workflow</small></span>
                        <span class="object-name">{{ workflowOptions.name }}</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Overview">
                <app-workflow-report [metricsData]="reportData"></app-workflow-report>
            </mat-tab>
            <!-- Settings Tab -->
            <mat-tab label="Settings">
                <div class="tab-content">
                    <app-client-object-settings [clientSettingsForm]="clientOptionsSettingsForm"
                                                [object]="workflowOptions"></app-client-object-settings>
                    <app-schedule-settings [scheduleSettingsForm]="scheduleSettingsForm"
                                           [scheduleSettings]="workflowOptions.scheduleSettings"></app-schedule-settings>
                    <app-notification-settings [notificationForm]="notificationsForm"
                                               [notificationSettings]="workflowOptions.notificationSettings"></app-notification-settings>
                </div>
            </mat-tab>
            <!-- Steps Tab -->
            <mat-tab label="Steps">
                <div class="tab-content">
                    <mat-accordion>
                        @for (step of workflowOptions.steps; track step; let i = $index) {
                            <mat-expansion-panel [expanded]="false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{ step.stepType }} - {{ step.name }}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                @if (stepForms[i]) {
                                    <form [formGroup]="stepForms[i]" class="step-form">
                                        <!-- Step Name -->
                                        <mat-form-field appearance="fill" class="full-width">
                                            <mat-label>Name</mat-label>
                                            <input formControlName="name" matInput placeholder="Enter step name">
                                        </mat-form-field>
                                        <!-- Step Type -->
                                        <mat-form-field appearance="fill" class="full-width">
                                            <mat-label>Type of Step</mat-label>
                                            <mat-select formControlName="stepType">
                                                @for (type of allowedStepTypes; track type) {
                                                    <mat-option [value]="type">{{ type }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        <!-- Action Type -->
                                        <mat-form-field appearance="fill" class="full-width">
                                            <mat-label>Action</mat-label>
                                            <mat-select formControlName="actionType">
                                                @for (action of allowedActionTypes; track action) {
                                                    <mat-option [value]="action">{{ action }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        <!-- Parameters Table -->
                                        @if (step.stepType) {
                                            <div class="parameters-section">
                                                <table [dataSource]="getParameters(step)" class="mat-elevation-z8"
                                                       mat-table>
                                                    <!-- Key Column -->
                                                    <ng-container matColumnDef="key">
                                                        <th *matHeaderCellDef mat-header-cell> Key</th>
                                                        <td *matCellDef="let param" mat-cell> {{ param.key }}</td>
                                                    </ng-container>
                                                    <!-- Value Column -->
                                                    <ng-container matColumnDef="value">
                                                        <th *matHeaderCellDef mat-header-cell> Value</th>
                                                        <td *matCellDef="let param" mat-cell> {{ param.value }}</td>
                                                    </ng-container>
                                                    <!-- Action Column -->
                                                    <ng-container matColumnDef="action">
                                                        <th *matHeaderCellDef mat-header-cell> Action</th>
                                                        <td *matCellDef="let param" mat-cell>
                                                            <button (click)="deleteProperty(i, param.key)" color="warn"
                                                                    mat-button>Remove
                                                            </button>
                                                        </td>
                                                    </ng-container>
                                                    <tr *matHeaderRowDef="['key', 'value', 'action']"
                                                        mat-header-row></tr>
                                                    <tr *matRowDef="let row; columns: ['key', 'value', 'action'];"
                                                        mat-row></tr>
                                                </table>
                                                <!-- Add Parameter -->
                                                <div class="add-parameter d-flex align-items-center">
                                                    <mat-form-field appearance="fill" class="full-width">
                                                        <mat-label>Key</mat-label>
                                                        <mat-select [(value)]="keyToAdd[i]">
                                                            @for (key of allowedParameters[step.stepType]; track key) {
                                                                <mat-option [value]="key.name">
                                                                    {{ key.name }}
                                                                </mat-option>
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="fill" class="full-width">
                                                        <mat-label>Value</mat-label>
                                                        @if (hasOptions(step.stepType, keyToAdd[i])) {
                                                            <mat-select [(value)]="valueToAdd[i]">
                                                                @for (option of getOptions(step.stepType, keyToAdd[i]); track option) {
                                                                    <mat-option [value]="option">
                                                                        {{ option }}
                                                                    </mat-option>
                                                                }
                                                            </mat-select>
                                                        } @else {
                                                            <input [(ngModel)]="valueToAdd[i]" [ngModelOptions]="{standalone: true}"
                                                                   matInput
                                                                   placeholder="Enter value"
                                                                   type="{{ getType(step.stepType, keyToAdd[i]) }}">
                                                        }
                                                    </mat-form-field>
                                                    <button (click)="addProperty(i)" color="primary" mat-icon-button>
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        <!-- Remove Step Button -->
                                        <div class="remove-step">
                                            <button (click)="removeStep(i)" color="warn" mat-button>Remove Step</button>
                                        </div>
                                    </form>
                                }
                            </mat-expansion-panel>
                        }
                    </mat-accordion>
                    <!-- Add Step Button -->
                    <div class="add-step">
                        <button mat-raised-button color="primary" (click)="addStep()">Add Step</button>
                    </div>
                </div>
            </mat-tab>
            <!-- Run Tab -->
            <mat-tab label="Run">
                <div class="tab-content">
                    <div class="run-actions d-flex">
                        <button mat-raised-button color="accent" (click)="runWorkflow()" [disabled]="isRunning">
                            {{ isRunning ? 'Running...' : 'Run' }}
                        </button>
                    </div>
                    @if (runningWorkflow && !(runningWorkflow.updateMessages.length > 1)) {
                        <div>
                            <p>Waiting for available worker. This could take up to 60 seconds.</p>
                        </div>
                    }
                    <!-- display a list of messages from runningTask.UpdateMessages (a string array) -->
                    @if (runningWorkflow) {
                        @for (message of runningWorkflow.updateMessages; track message) {
                            <div>
                                <p>{{ message }}</p>
                            </div>
                        }
                    }
                    <!-- Results Table -->
                    @if (results.length) {
                        <div class="results-table">
                            <table [dataSource]="results" class="mat-elevation-z8" mat-table>
                                <!-- URL Column -->
                                <ng-container matColumnDef="url">
                                    <th *matHeaderCellDef mat-header-cell> URL</th>
                                    <td *matCellDef="let element" mat-cell> {{ element.Url }}</td>
                                </ng-container>
                                <!-- Dynamic Columns for Steps -->
                                @for (step of results[0].Steps; track step; let i = $index) {
                                    <ng-container [matColumnDef]="getStepColumnName(i)">
                                        <th *matHeaderCellDef mat-header-cell> {{ getStepName(i) }}</th>
                                        <td *matCellDef="let element"
                                            mat-cell> {{ element.Steps[i]?.Result[getStepName(i)] }}
                                        </td>
                                    </ng-container>
                                }
                                <tr *matHeaderRowDef="getStepColumns()" mat-header-row></tr>
                                <tr *matRowDef="let row; columns: getStepColumns();" mat-row></tr>
                            </table>
                        </div>
                    }
                </div>
            </mat-tab>
            <mat-tab label="Previous runs">
                <div class="tab-content">
                    <app-workflow-previous-runs [allTasks]="allTasks"
                                                [workflowOptions]="workflowOptions"></app-workflow-previous-runs>
                </div>
            </mat-tab>
        </mat-tab-group>
        <!-- Save and Delete Buttons -->
        @if ([1, 4, 5].indexOf(matTabGroup.selectedIndex!) === -1) {
            <div class="action-buttons action-buttons">
                <button (click)="save()" [disabled]="isSaving || !isFormTouched()" color="primary" mat-raised-button>
                    {{ isSaving ? 'Saving...' : 'Save' }}
                </button>
                <button (click)="delete()" [disabled]="isDeleting" color="warn" mat-raised-button>
                    {{ isDeleting ? 'Deleting...' : 'Delete' }}
                </button>
        </div>
        }
    </div>
    </div>
}
